var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 21.3336H16.0109M16.0002 13.3336V17.3336M14.1002 6.95628L4.68957 22.667C4.49567 23.003 4.39312 23.3839 4.3921 23.7719C4.39108 24.1599 4.49163 24.5414 4.68375 24.8784C4.87588 25.2155 5.15289 25.4964 5.48723 25.6932C5.82158 25.89 6.20162 25.9959 6.58957 26.0003H25.4109C25.799 25.9963 26.1793 25.8907 26.5139 25.6939C26.8485 25.4972 27.1257 25.2163 27.3179 24.8791C27.5101 24.5419 27.6106 24.1602 27.6093 23.7721C27.6081 23.384 27.5052 23.0029 27.3109 22.667L17.9016 6.95628C17.7037 6.62952 17.4248 6.35933 17.092 6.1718C16.7592 5.98427 16.3836 5.88574 16.0016 5.88574C15.6195 5.88574 15.244 5.98427 14.9111 6.1718C14.5783 6.35933 14.2995 6.62952 14.1016 6.95628",
    stroke: "#0D216D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic-alert.2b000526e6fdd0feb169746a6087e477.svg";
export { ForwardRef as ReactComponent };